// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ujwy","top":"styles_top__4S38x","left":"styles_left__29tA8","description":"styles_description__1OsFl"};